import React from 'react';

/*
  ToolMonogram — the face of an agent-built tool wherever an official tool wears its
  ClaudeToolIcon: the Tools rail and the ACP dock tabs. Two letters of its name in a hairline
  square (several user tools would otherwise all wear the same wrench); colour is currentColor,
  so it follows the row's rest / hover / active states exactly like the line icons beside it.
*/
export const monogram = (name) => {
  const words = String(name || '').replace(/[^\p{L}\p{N} ]/gu, ' ').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  return (words.length >= 2 ? words[0][0] + words[1][0] : words[0].slice(0, 2)).toUpperCase();
};

export default function ToolMonogram({ name, size = 14, className = '' }) {
  return (
    <span
      aria-hidden
      className={`inline-grid place-items-center border border-current font-black leading-none select-none ${className}`}
      style={{ height: size + 2, minWidth: size + 2, fontSize: Math.max(7, Math.round(size * 0.5)), letterSpacing: '0.02em', padding: '0 1px' }}
    >
      {monogram(name)}
    </span>
  );
}
